import {IState, IStateParamsService} from 'angular-ui-router';
import {ApplicationPropertyRS} from '../admin/service/applicationPropertyRS.rest';
import AuthServiceRS from '../authentication/service/AuthServiceRS.rest';
import AnlaufstelleRS from '../core/service/AnlaufstelleRS.rest';
import BenutzerRS from '../core/service/BenutzerRS.rest';
import RoleUtilService from '../core/service/RoleUtilService';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import TSAnlaufstelle from '../models/TSAnlaufstelle';
import TSBenutzer from '../models/TSBenutzer';
import DVBernUtil from '../utils/DVBernUtil';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;
import IQService = angular.IQService;

benutzerverwaltungRun.$inject = ['RouterHelper'];

/* @ngInject */
export function benutzerverwaltungRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        {
            //deprecated
            name: 'benutzerverwaltunganlaufstelle',
            template: '<dv-benutzerverwaltung-anlaufstelle-view benutzer-to-show="$resolve.benutzerList" allowed-anlaufstellen="$resolve.anlaufstelleList"></dv-benutzerverwaltung-anlaufstelle-view>',
            url: '/benutzerverwaltunganlaufstelle',
            resolve: {
                anlaufstelleList: loadAnlaufstellen,
                benutzerList: loadBenutzerOfAnlaufstelle
            }
        },
        {
            name: 'benutzereditanlaufstelle',
            template: '<dv-benutzeredit-anlaufstelle-view  anlaufstelle="$resolve.anlaufstelle" '
            + 'benutzer="$resolve.benutzer" '
            + 'sachbearbeiter-list="$resolve.sachbearbeiterList" schaetzer-list="$resolve.schaetzerList"></dv-benutzeredit-anlaufstelle-view>',
            url: '/anlaufstelle/:anlaufstelleId/benutzeredit/:benutzerId',
            resolve: {
                anlaufstelle: loadAnlaufstelle,  //todo homa brauchts das?
                benutzer: loadAnlaufstelleBenutzer,

            },
            params: {benutzer: null, benutzerId: null, anlaufstelleId: null}
        },
        {
            name: 'benutzerverwaltung',
            template: '<dv-benutzer-list-view  benutzer-to-show="$resolve.benutzer" </dv-benutzer-list-view>',
            url: '/benutzerverwaltung',
            resolve: {
                benutzer: loadAdvancedBenutzers,

            },
        },
        {
            name: 'benutzeredit',
            template: '<dv-benutzeredit-view  benutzer="$resolve.benutzer" </dv-benutzeredit-view>',
            url: '/benutzerverwaltung/:benutzerId',
            resolve: {
                benutzer: loadBenutzerToEdit,

            },
            params: {benutzer: null, benutzerId: null}
        },
        {
            name: 'benutzerregistrierung',
            template: '<benutzer-reg-view site-key="$resolve.siteKey"></benutzer-reg-view>',
            url: '/benutzerregistrierung',
            resolve: {
                siteKey: loadSiteKey
            }
        },
        {
            name: 'profile',
            template: '<dv-benutzerprofil-view  benutzer="$resolve.benutzer" </dv-benutzeredit-view>',
            url: '/profile',
            resolve: {
                benutzer: loadBenutzerForProfile,

            }
        },

    ];
}

loadSiteKey.$inject = ['ApplicationPropertyRS'];

export function loadSiteKey(ApplicationPropertyRS: ApplicationPropertyRS): IPromise<string> {
    return ApplicationPropertyRS.getRecaptchaSiteKey();

}

loadAnlaufstellen.$inject = ['BenutzerRS', 'AnlaufstelleRS', 'AuthServiceRS', 'RoleUtilService', '$q'];

export function loadAnlaufstellen(BenutzerRS: BenutzerRS, AnlaufstelleRS: AnlaufstelleRS, AuthServiceRS: AuthServiceRS,
                                  RoleUtilService: RoleUtilService, $q: IQService): IPromise<Array<TSAnlaufstelle>> {
    //admins may view all anlaufstellen
    if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAdministratorRoles())) {
        return AnlaufstelleRS.getAllAnlaufstellen();
        //anlaufstellenuser may view just one
    } else if (AuthServiceRS.isOneOfRoles(RoleUtilService.getAnlaufstelleVerwalterOnlyRole())) {
        let principal = AuthServiceRS.getPrincipal();
        if (principal) {
            return BenutzerRS.getAnlaufstellenForBenutzer(principal.id);
        }
    }
    return $q.when([]);

}

loadAnlaufstelle.$inject = ['$stateParams', 'AnlaufstelleRS', '$q'];

export function loadAnlaufstelle($stateParams: IAnlaufstelleBenutzerEditStateParams,
                                 AnlaufstelleRS: AnlaufstelleRS, $q: IQService): IPromise<TSAnlaufstelle | undefined> {
    if ($stateParams.anlaufstelleId) {
        return AnlaufstelleRS.findAnlaufstelle($stateParams.anlaufstelleId);
    }
    return $q.when(undefined);

}

loadBenutzerOfAnlaufstelle.$inject = ['BenutzerRS', 'AnlaufstelleRS', 'AuthServiceRS', 'RoleUtilService', '$q'];

export function loadBenutzerOfAnlaufstelle(BenutzerRS: BenutzerRS, AnlaufstelleRS: AnlaufstelleRS, AuthServiceRS: AuthServiceRS,
                                           RoleUtilService: RoleUtilService, $q: IQService): IPromise<Array<TSBenutzer>> {
    //load the list of users of the first anlaufstelle we are permitted to view
    return loadAnlaufstellen(BenutzerRS, AnlaufstelleRS, AuthServiceRS, RoleUtilService, $q).then((allowedAnlaufstellen) => {
        if (allowedAnlaufstellen.length !== 0) {
            return AnlaufstelleRS.getBenutzerOfAnlaufstelle(allowedAnlaufstellen[0].id);

        } else {
            return $q.when([]);
        }
    });

}

loadAdvancedBenutzers.$inject = ['BenutzerRS', 'AuthServiceRS', 'RoleUtilService', '$q'];

export function loadAdvancedBenutzers(BenutzerRS: BenutzerRS, AuthServiceRS: AuthServiceRS,
                                      RoleUtilService: RoleUtilService, $q: IQService): IPromise<Array<TSBenutzer>> {
    //load the list of users
    return BenutzerRS.loadAdvancedBenutzer();
}

loadAnlaufstelleBenutzer.$inject = ['$stateParams', 'AnlaufstelleRS', '$q', '$log'];

export function loadAnlaufstelleBenutzer($stateParams: IAnlaufstelleBenutzerEditStateParams,
                                         AnlaufstelleRS: AnlaufstelleRS, $q: IQService,
                                         $log: ILogService): IPromise<TSBenutzer | undefined> {
    if ($stateParams) {
        let anlaufstelleId = $stateParams.anlaufstelleId;
        let benutzerId = $stateParams.benutzerId;
        let passedBenutzer = $stateParams.benutzer;
        if (passedBenutzer) {
            return $q.when(passedBenutzer);
        }
        if (anlaufstelleId && benutzerId) {
            let benutzerPromise: IPromise<Array<TSBenutzer>>;
            //wir haben aktuell keine methode mit der direkt der Benutzer geladen werden kann, daher laden wir mal alle und filtern danach
            benutzerPromise = AnlaufstelleRS.getBenutzerOfAnlaufstelle(anlaufstelleId);
            return benutzerPromise.then((allBenutzerOfAnlaufstelle) => {
                let benutzer: TSBenutzer;
                let i = DVBernUtil.getIndexOfElementwithIDById(benutzerId, allBenutzerOfAnlaufstelle);
                if (i >= 0) {
                    return $q.when(allBenutzerOfAnlaufstelle[i]);
                } else {
                    $log.error('Can`t open requested Benutzer of anlaufstelle. creating a new one...');
                    return $q.when(new TSBenutzer());

                }
            })
        }
    }
    //no infos about existing user passed, assume we need a new one
    return $q.when(new TSBenutzer());
}

loadBenutzerToEdit.$inject = ['$stateParams', 'BenutzerRS', '$q', '$log'];

export function loadBenutzerToEdit($stateParams: IBenutzerEditStateParams,
                                   BenutzerRS: BenutzerRS, $q: IQService, $log: ILogService): IPromise<TSBenutzer | undefined> {
    if ($stateParams) {
        let benutzerId = $stateParams.benutzerId;
        let passedBenutzer = $stateParams.benutzer;
        if (passedBenutzer) {
            return $q.when(passedBenutzer);
        }
        if (benutzerId) {
            let benutzerPromise: IPromise<TSBenutzer | undefined>;
            benutzerPromise = BenutzerRS.findBenutzer(benutzerId);
            return benutzerPromise.then((foundBenutzer) => {
                if (foundBenutzer) {
                    return foundBenutzer;
                } else {
                    $log.error('Can`t find requested Benutzer. Creating a new one...');
                    return $q.when(new TSBenutzer());

                }
            })
        }
    }
    //no infos about existing user passed, assume we need a new one
    return $q.when(new TSBenutzer());
}

loadBenutzerForProfile.$inject = ['$stateParams', 'BenutzerRS', '$q', '$log', 'AuthServiceRS'];

export function loadBenutzerForProfile($stateParams: IBenutzerEditStateParams,
                                       BenutzerRS: BenutzerRS, $q: IQService, $log: ILogService,
                                       AuthServiceRS: AuthServiceRS): IPromise<TSBenutzer | undefined> {
    let currentPrincipal = AuthServiceRS.getPrincipal()

    if (currentPrincipal) {
        let benutzerId = currentPrincipal.id;
        if (benutzerId) {
            let benutzerPromise: IPromise<TSBenutzer | undefined>;
            benutzerPromise = BenutzerRS.findBenutzer(benutzerId);
            return benutzerPromise.then((foundBenutzer) => {
                if (foundBenutzer) {
                    return foundBenutzer;
                } else {
                    $log.error('Can`t find requested Benutzer. Creating a new one...');
                    return $q.when(new TSBenutzer());

                }
            })
        }
    }
    //no infos about existing user passed, assume we need a new one
    return $q.when(new TSBenutzer());
}

//PARAMS

export class IBenutzerEditStateParams implements IStateParamsService {
    benutzerId: string;
    benutzer: TSBenutzer;
}

export class IAnlaufstelleBenutzerEditStateParams implements IStateParamsService {
    anlaufstelleId: string;
    benutzerId: string;
    benutzer: TSBenutzer;
}





// WEBPACK FOOTER //
// ./src/app/benutzerverwaltung/benutzerverwaltung.route.ts